import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  ChangeDetectorRef,
  NgZone,
  ViewChild,
  OnDestroy,
} from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  ValidatorFn,
  FormControl,
  ValidationErrors,
  AbstractControl,
  FormArray,
  NgForm,
} from "@angular/forms";
import * as CryptoJS from "crypto-js";
import { OnboardingService } from "../../shared/service/onboarding.service";
import {
  EmployeeCarLeaseDetails,
  EmployeeCarLeases,
  EmployeeSalaryAdvanceDetails,
  EmployeeSalaryAdvances,
  HRempHiringDetails,
  OnboardingHRDetail,
} from "../../shared/models/OnboardingHRDetail";
import { Router, ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { DatePipe, formatDate } from "@angular/common";
import { AppConfig } from "../../app.config";
import { UserService } from "../../shared/service/user.service";
import { DepartmentsService } from "../../shared/service/departments.service";
import { CadreService } from "../../shared/service/cadre.service";
import { isNullOrUndefined } from "util";
import {
  DesignationDialogComponent,
  DesignationDialog,
} from "../../shared/components/designation-dialog/designation-dialog.component";
import { MatDialog, MatSelect } from "@angular/material";
import {
  MomentDateAdapter,
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
} from "@angular/material-moment-adapter";
import * as momentTz from "moment-timezone";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material/core";
import {
  DepartmentDialogComponent,
  DepartmentDialog,
} from "../../shared/components/department-dialog/department-dialog.component";
import {
  CadreDialog,
  CadreDialogComponent,
} from "../../shared/components/cadre-dialog/cadre-dialog.component";
import {
  ProfilesourceDialog,
  ProfilesourceDialogComponent,
} from "../../shared/components/profilesource-dialog/profilesource-dialog.component";
import { EmployeeService } from "../../shared/service/employee.service";
import { OnboardOTP } from "../../shared/models/OnboardOTP";
// import { moment } from "ngx-bootstrap/chronos/test/chain";
import * as _moment from "moment";
import {
  ConfirmDialogComponent,
  ConfirmDialogModel,
} from "../../shared/components/confirm-dialog/confirm-dialog.component";
import {
  BonusDialog,
  CompensationDialogComponent,
} from "../../shared/components/compensation-dialog/compensation-dialog.component";
import { BasicEmployeeDetails } from "../../shared/models/basicemployeedetails.model";
import { FileUploadService } from "../../shared/service/fileUpload.service";
import { File_Types, Resume_File_Types } from "../../shared/UploadFileTypes";
const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: "LL",
  },
  display: {
    dateInput: "DD-MMM-YYYY",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};
@Component({
  selector: "app-hr-hiring-details",
  templateUrl: "./hr-hiring-details.component.html",
  styleUrls: ["./hr-hiring-details.component.css"],
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class HrHiringDetailsComponent implements OnInit, OnDestroy {
  datePipe: DatePipe;
  error: string;
  isLoader: boolean = true;
  LoginEmpCode: any;
  changeTab: any;
  @Input() EmpId: number;
  @Input() empCode: number;
  @Output("hrHiringDetValue") hrHiringDetValue = new EventEmitter();
  filteredList: any;
  hrdetailsform: FormGroup;
  hrCtcDetailsForm: FormGroup;
  gettingBasicDet: BasicEmployeeDetails;
  IsExpand = true;
  jobsources: any;
  jobPlatform: any;
  selectedProfileSource: number;
  filteredEmpList: any;
  empList: any[] = [];
  cadreId: any;
  RecruiterId: any;
  RecruiterDesignation: any;
  HREmp: HRempHiringDetails;
  cadresList: any = [];
  departmentId: any;
  departmentsList: any = [];
  designationId: any;
  designationsList: any[];
  Required: boolean = false;
  employeelist: any[] = [];
  RequiredDept: boolean = false;
  RequiredCadre: boolean = false;
  EmpCode: number;
  showOtherControl = false;
  oldJobSource: string = null;
  originalHiringDetails: any;
  result: any;
  bonusDetails: FormArray = this.formBuilder.array([]);
  bonusOptions: any;
  selectedBonusOptions: string[] = [];
  Months: any[] = [];
  carLeaseMonths: any[] = [];
  filteredSalaryAdvanceEmpList: any;
  salaryAdvanceApprvrId: any[] = [];
  destroyed = false;
  monthYearRegex =
    /^(?:Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-\d{2}$/;
  submitted: any;
  maxPayoutDate = new Date();
  OtpText: boolean;
  slug: string;
  exception: boolean;
  _onboardOTP: OnboardOTP;
  isAllowAccess: boolean = false;
  MAX_SIZE: number = 1048576;
  CTCComponentsList = [];
  mainCmp = [
    "EffectiveDate",
    "FixedCTC",
    "IPA",
    "CPA",
    "Performance Bonus",
    "Retention Bonus",
    "Variable Pay",
  ];
  newlyAddedCtcCmp = [];
  newlyAddedBonusCmp = [];
  allCmpCount = 0;
  bonusCmp = ["Stretch Bonus", "Long Term Bonus"];
  staticCmp = ["JoiningBonus", "RelocationEligibility"];
  offerCmp = ["OfferLetterDocumentPath"];
  arrFilesList = [];
  doJ: any;
  minDOJ: any;
  iconVisible: boolean = false;
  privateKeyBase64: string = "b14ca5898a4e4133bbce2ea2315a1916";
  encryptedData: any = ""; // Base64 encrypted data (received from the backend)
  decryptedData: any = ""; // Decrypted data
  currentYear: any;
  currentMonth: any;
  permission: any;
  hasAccess = false;
  MobileNo: any;
  hasAddPermission = false;
  originalGetData: any;
  prepareNewUpdatedData: any;
  isUpdated = null;

  constructor(
    private emp_Svc: EmployeeService,
    private onboardsvc: OnboardingService,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private config: AppConfig,
    private hrSvc: OnboardingService,
    private router: Router,
    private toastr: ToastrService,
    private cadreSvc: CadreService,
    private deptSvc: DepartmentsService,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private zone: NgZone,
    private cdr: ChangeDetectorRef,
    private _onboardingService: OnboardingService,
    private file_Svc: FileUploadService
  ) {
    this.HREmp = new HRempHiringDetails();
    this.HREmp.JoiningBonus = "0";
  }

  async ngOnInit() {
    this.OtpText = false;
    this._onboardOTP = new OnboardOTP();
    this.currentYear = new Date().getFullYear();
    this.currentMonth = new Date().getMonth();
    this.maxPayoutDate = new Date(this.currentYear, this.currentMonth, 27);

    this.LoginEmpCode = this.userService.getEmpCode();
    this.initializeForm();
    await this.getEmployeeList();
    this.getPermissions();
    this.checkPermission();
    this.route.params.subscribe((params) => {
      this.EmpCode = params["empCode"];
      this.EmpId = params["empCode"];
    });
    this.getBasicEmployeeByCode();
    this.getBasicEmployeeByCodeforNumber();
    if (!isNullOrUndefined(this.EmpCode)) {
      this.getJobSources();
      this.getBonusList();

      this.getData();

    } else {
      //this.addItem();
      this.getBonusList();
      this.getDesignations();
      this.getJobSources();
    }

    this.empCode = this.userService.getEmpCode();


    this.getDepartments();
    this.getCadres();
    this.getAllEmplist();

    //this.onboardingform.get('RecruiterId').valueChanges.subscribe(value => {
    //  this.doEmpFilter(value); // Filter list based on input value
    //});
    this.hrdetailsform.get("ProfileSource").valueChanges.subscribe((val) => {
      if (val === "Vendor" || val === "Referral" || val === "RPO") {
        this.hrdetailsform.controls["ProfileSourceCategoryTwo"].setValidators([
          Validators.required,
          Validators.maxLength(15),
          Validators.pattern("^\\d{1,12}(\\.\\d{0,2})?$"),
        ]);
      } else {
        this.hrdetailsform.controls[
          "ProfileSourceCategoryTwo"
        ].clearValidators();
      }
    });
    //setTimeout(() => {
    //  this.isLoader = false;
    //}, 1500);
  }

  checkPermission() {
    var permission = this.userService.userInfo.permissions.find(
      (i) => i.Menu === "Master"
    );
    this.hasAddPermission =
      permission != null
        ? permission.AddingPermission || permission.HasFullAccess
        : false;
  }

  ngOnDestroy(): void {
    this.destroyed = true;
  }

  initializeForm() {
    this.bonusDetails = this.formBuilder.array([]);
    const nonWhitespaceRegExp: RegExp = new RegExp("\\S");
    this.hrdetailsform = this.formBuilder.group({
      ProfileSource: [
        "",
        [Validators.required, this.requireMatchProfileSource.bind(this)],
      ],
      ProfileSourceCategoryOne: ["", [Validators.required]],
      ProfileSourceCategoryTwo: [
        "",
        // [
        //   Validators.required,
        //   Validators.maxLength(15),
        //   this.customValidator
        // ],
      ],
      HiringType: ["", [Validators.required]],
      RecruiterId: [
        "",
        [Validators.required, this.requireMatchRecruiterId.bind(this)],
      ],
      RecruiterDesignationId: [""],
      JoiningBonus: [
        "",
        [
          Validators.pattern("^\\d{1,12}(\\.\\d{0,2})?$"),
          Validators.maxLength(15),
        ],
      ],
      fixedCTC: [],
      relocationEligibility: [],
      // OfferLetterFile: [],
      offerLetterDetails: [],
      bonusDetails: this.bonusDetails,
    });
    this.hrCtcDetailsForm = this.formBuilder.group({
      EffectiveDate: ["", [Validators.required]],
      FixedCTC: [
        "",
        [
          Validators.pattern("^\\d{1,12}(\\.\\d{0,2})?$"),
          Validators.maxLength(15),
        ],
      ],
      IPA: [
        "",
        [
          Validators.pattern("^\\d{1,12}(\\.\\d{0,2})?$"),
          Validators.maxLength(15),
        ],
      ],
      CPA: [
        "",
        [
          Validators.pattern("^\\d{1,12}(\\.\\d{0,2})?$"),
          Validators.maxLength(15),
        ],
      ],
      CTC: [
        "",
        [
          Validators.pattern("^\\d{1,12}(\\.\\d{0,2})?$"),
          Validators.maxLength(15),
        ],
      ],
      "Performance Bonus": [
        "",
        [
          Validators.pattern("^\\d{1,12}(\\.\\d{0,2})?$"),
          Validators.maxLength(15),
        ],
      ],
      "Retention Bonus": [
        "",
        [
          Validators.pattern("^\\d{1,12}(\\.\\d{0,2})?$"),
          Validators.maxLength(15),
        ],
      ],
      "Stretch Bonus": [
        "",
        [
          Validators.pattern("^\\d{1,12}(\\.\\d{0,2})?$"),
          Validators.maxLength(15),
        ],
      ],
      "Variable Pay": [
        "",
        [
          Validators.pattern("^\\d{1,12}(\\.\\d{0,2})?$"),
          Validators.maxLength(15),
        ],
      ],
      "Long Term Bonus": [
        "",
        [
          Validators.pattern("^\\d{1,12}(\\.\\d{0,2})?$"),
          Validators.maxLength(15),
        ],
      ],
      RelocationEligibility: "null",
      OfferLetterDocumentPath: "",
    });
  }

  splitCamelCase(value: string): string {
    return value.replace(/(?<!^)([A-Z])/g, " $1");
  }

  getPermissions() {
    this.permission = this.userService.userInfo.permissions.find(
      (i) => i.Name === "Compensation & Benefits"
    );
    this.hasAccess =
      this.permission != null ? this.permission.HasFullAccess : false;
  }

  getBasicEmployeeByCode() {
    this.emp_Svc.getBasicEmployeeById(this.LoginEmpCode).subscribe(
      (data: any) => {
        this._onboardOTP.Slug = data && data.SecondaryEmail;
        this.gettingBasicDet = data;
        //console.log(this.gettingBasicDet)
        this.doJ = new Date(this.gettingBasicDet.DOJ);
        this.doJ.setHours(0, 0, 0, 0);
        this.minDOJ = this.doJ
        //this.doJ > new Date(this.currentYear, 3, 1)
        //  ? this.doJ
        //  : new Date(this.currentYear, 3, 1);
      },
      (error) => (this.error = error)
    );
  }

  //slugify(input) {
  //  return input.replace(/[@.]/g, "-");
  //}

  updateRemainingObject(event, index) {
    this.prepareNewUpdatedData = this.HREmp.employeeBonusDetailsList;
  }

  ctcCalculationFun(event, index) {
    let filteredList = this.bonusOptions
      .filter(({ IsCTC, Name }) => IsCTC === true)
      .map(({ Name }) => Name);

    let finalData = this.HREmp.employeeBonusDetailsList;
    let count = 0;
    filteredList = ["FixedCTC", ...filteredList];
    if (filteredList && filteredList.length > 0) {
      filteredList = [...new Set(filteredList)]
      filteredList.map((item) => {
        count = Number(count) + Number(finalData[index][item] || 0);
      });
    }
    finalData[index].CTC = count;

    this.HREmp.employeeBonusDetailsList = finalData;
  }

  activate() {
    const tempObj = {
      empCode: this.LoginEmpCode,
      OTPCode: this._onboardOTP.OTPCode,
    };
    if (this._onboardOTP) {
      this._onboardingService.validateOTP(tempObj).subscribe(
        (data: any) => {
          this.error = "";
          if (data.Success == true) {
            this.exception = false;
            this.OtpText = false;
            this.isAllowAccess = true;
            this.cdr.detectChanges();
          } else {
            this.exception = true;
            this.error = data.ErrorMessage;
            this.toastr.warning("Invalid OTP");
          }
        },
        (error) => (this.error = error)
      );
    }
  }

  getBasicEmployeeByCodeforNumber() {
    if (this.LoginEmpCode != null) {
      if (this.gettingBasicDet != null) {
        this.MobileNo = this.gettingBasicDet.MobileNo;
      }
      else {
        this.emp_Svc.getBasicEmployeeById(this.LoginEmpCode).subscribe((data: any) => {
          this.MobileNo = data.MobileNo;
        });
      }
    }
    return this.MobileNo;
  }

  generateOTP() {
    this.error = "Wait for few seconds....";
    //const slugValue = this.slugify(this.LoginEmpCode);
    this._onboardingService
      .generateOTP(this.LoginEmpCode, "hiringInfo")
      .subscribe(
        (data: any) => {
          this.error = "";
          if (data.Success == true) {
            this.exception = false;
            this.OtpText = true;
            const num = this.getBasicEmployeeByCodeforNumber();
            this.toastr.success(
              "OTP has been sent to mobile# XXXXXX" + num.slice(-4)
            );
            this.cdr.detectChanges();
          }
          else {
            this.exception = true;
            this.error = data.ErrorMessage;
            this.toastr.warning(this.error);
          }
        },
        (error) => (this.error = error)
      );
  }

  getfileName() {
    if (this.HREmp != null && this.HREmp.OfferLetterDocumentName != null) {
      return (
        this.gettingBasicDet.EmpCode +
        "_" +
        this.gettingBasicDet.NamePerRecords +
        "_Offer Letter"
      );
    } else return null;
  }

  getCtcFileNames(item, index) {
    if (item != null && item.OfferLetterDocumentPath != null && this.gettingBasicDet != null) {
      if (this.HREmp.employeeBonusDetailsList.length - 1 === index) {
        return (
          this.gettingBasicDet.EmpCode +
          "_" +
          this.gettingBasicDet.NamePerRecords +
          "_Offer Letter"
        );
      } else {
        return (
          this.gettingBasicDet.EmpCode +
          "_" +
          this.gettingBasicDet.NamePerRecords +
          "_Appraisal Letter"
        );
      }
    } else return null;
  }

  handleFile(event, itemData, j = null) {
    if (event.target.files == undefined) {
      // this.HREmp.OfferLetterFile = null;
      this.HREmp.offerLetterDetails = [];
    }
    const files: FileList = event.target.files;
    if (files && files.length > 0) {
      if (!this.validFileType(files[0])) {
        this.toastr.warning(
          "File name " + files[0].name + ": Not a valid file type."
        );
        event.srcElement.value = null;
        event.currentTarget.value = null;
      }
      //  Don't allow file sizes over 1MB
      if (files[0].size < this.MAX_SIZE) {
        const fileDataObj = {
          EffectiveDate: momentTz
            .tz(itemData.EffectiveDate, "Asia/Kolkata")
            .format("YYYY-MM-DD hh:mm:ss.SSS"),
          EmpCode: this.HREmp.EmpCode,
          JoiningBonus: itemData.JoiningBonus,
          RelocationEligibility: this.HREmp.RelocationEligibility,
          OfferLetterDocumentName: this.HREmp.OfferLetterDocumentName,
          OfferLetterFile: this.file_Svc.readAndUploadFile(files),
        };
        this.arrFilesList.push(fileDataObj);
        this.HREmp.offerLetterDetails = this.arrFilesList;
        this.HREmp.OfferLetterDocumentPath = null;
        this.isUpdated = j;
      } else {
        this.toastr.warning(
          " File: " +
          files[0].name +
          " exceeds 1MB hence it cannot be uploaded."
        );
        event.srcElement.value = null;
        event.currentTarget.value = null;
      }
    }
  }

  validFileType(file) {
    let types = [...File_Types, ...Resume_File_Types];
    return types.includes(file.type);
  }

  addItem(item = null) {
    if (item != null) {
      var row = this.formBuilder.group({
        Id: item.Id,
        EmpCode: item.EmpCode,
        BonusId: item.BonusId,
        Name: item.Name,
        Amount: item.Amount,
      });
    } else {
      var row = this.formBuilder.group({
        Id: [""],
        EmpCode: [""],
        BonusId: [""],
        Name: [""],
        Amount: [""],
      });
    }
    this.bonusDetails.push(row);
  }

  deleteSalaryAdvance(index, event) {
    event.stopPropagation();
    const message = `Please confirm if you want to delete this record?`;
    var deleteType = "Record";
    const dialogData = new ConfirmDialogModel(" ", message, deleteType);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.HREmp.employeeSalaryAdvances.splice(index, 1);
          this.cdr.detectChanges();
        }
      },
      (error) => {
        this.result = error;
      }
    );
  }

  deleteCarLease(index, event) {
    event.stopPropagation();
    const message = `Please confirm if you want to delete this record?`;
    var deleteType = "Record";
    const dialogData = new ConfirmDialogModel(" ", message, deleteType);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.HREmp.employeeCarLeases.splice(index, 1);
          this.cdr.detectChanges();
        }
      },
      (error) => {
        this.result = error;
      }
    );
  }

  deleteItem(index) {
    const message = `Please confirm if you want to delete this record?`;
    var deleteType = "Record";
    const dialogData = new ConfirmDialogModel(" ", message, deleteType);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.bonusDetails.value.splice(index, 1);
          var array = this.bonusDetails.value;
          this.bonusDetails.clear();
          for (var i = 0; i < array.length; i++) {
            this.onSelectionChange(i, array[i].Name);
            this.addItem(array[i]);
          }
          this.cdr.detectChanges();
          this.hrHiringDetValue.emit(this.HREmp);
        }
      },
      (error) => {
        this.result = error;
      }
    );
  }

  getObjectState() {
    const originalHiringDetailsTemp = this.originalHiringDetails;
    const currentHiringDetailsTemp = this.HREmp;
    var hiringDetailsVal =
      JSON.stringify(originalHiringDetailsTemp) ===
      JSON.stringify(currentHiringDetailsTemp);
    return !hiringDetailsVal;
  }

  private readonly customValidator: ValidatorFn = (c) => {
    return (this.HREmp && this.HREmp.ProfileSource == "Vendor") ||
      (this.HREmp && this.HREmp.ProfileSource == "Referral") ||
      (this.HREmp && this.HREmp.ProfileSource == "RPO")
      ? Validators.pattern("^\\d{1,12}(\\.\\d{0,2})?$")
      : Validators.nullValidator(c);
  };

  getHiringDetails() {
    this.submitted = true;
    this.cdr.detectChanges();
    this.HREmp.EmpCode = this.EmpCode;
    this.datePipe = new DatePipe("en-US");
    this.HREmp.employeeBonusDetails = this.bonusDetails.value;
    if (
      this.HREmp.employeeBonusDetails != null &&
      this.HREmp.employeeBonusDetails.length > 0
    ) {
      for (var i = 0; i < this.HREmp.employeeBonusDetails.length; i++) {
        this.HREmp.employeeBonusDetails[i].EmpCode =
          this.HREmp.employeeBonusDetails[i].EmpCode > 0
            ? this.HREmp.employeeBonusDetails[i].EmpCode
            : this.EmpCode;
      }
    }

    if (
      this.HREmp.employeeSalaryAdvances != null &&
      this.HREmp.employeeSalaryAdvances.length > 0
    ) {
      var count = 0;
      for (var k = 0; k < this.HREmp.employeeSalaryAdvances.length; k++) {

        if (!isNullOrUndefined(this.HREmp.employeeSalaryAdvances[k].PayOutDate)) {

          this.HREmp.employeeSalaryAdvances[k].PayOutDate = new Date(this.datePipe.transform(this.HREmp.employeeSalaryAdvances[k].PayOutDate, this.config.dateFormat()));





        }
        this.HREmp.employeeSalaryAdvances[k].EmpCode = this.HREmp.employeeSalaryAdvances[k].EmpCode > 0 ? this.HREmp.employeeSalaryAdvances[k].EmpCode : this.EmpCode;
        this.HREmp.employeeSalaryAdvances[k].CreatedBy = this.HREmp.employeeSalaryAdvances[k].CreatedBy != null ? this.HREmp.employeeSalaryAdvances[k].CreatedBy : this.EmpCode.toString();
        this.HREmp.employeeSalaryAdvances[k].ModifiedBy = this.HREmp.employeeSalaryAdvances[k].ModifiedBy != null ? this.HREmp.employeeSalaryAdvances[k].ModifiedBy : this.EmpCode.toString();









        count = 0;

        const fromMonth = new Date(this.HREmp.employeeSalaryAdvances[k].FromMonth);

        const toMonth = new Date(this.HREmp.employeeSalaryAdvances[k].ToMonth);
        if (
          fromMonth.getFullYear() > toMonth.getFullYear() ||
          (fromMonth.getFullYear() === toMonth.getFullYear() &&
            fromMonth.getMonth() > toMonth.getMonth())
        ) {
          this.toastr.warning(
            "Recovery End Month cannot be earlier than the Start Month for the period " +
            formatDate(fromMonth, "MMM-yy", "en_US") +
            " to " +
            formatDate(toMonth, "MMM-yy", "en_US")
          );
          return;
        }
        if (
          this.HREmp.employeeSalaryAdvances[k].FromMonth == null ||
          this.HREmp.employeeSalaryAdvances[k].ToMonth == null ||
          this.HREmp.employeeSalaryAdvances[k].PayOutDate == null ||
          this.HREmp.employeeSalaryAdvances[k].Amount == null ||
          this.HREmp.employeeSalaryAdvances[k].ApproverCode == null
        ) {
          this.toastr.warning("Please fill required fields ");
          return;
        }
        if (this.HREmp.employeeSalaryAdvances[k].ApproverInvalid) {
          this.toastr.warning("Select valid approver for the period " + formatDate(this.HREmp.employeeSalaryAdvances[i].FromMonth, "MMM-yy", "en_US") + " to " + formatDate(this.HREmp.employeeSalaryAdvances[k].ToMonth, "MMM-yy", "en_US"));













          return;
        }
        if (this.HREmp.employeeSalaryAdvances[k].Amount == 0) {
          this.toastr.warning(
            "Salary Advance Amount must be greater than 0 for the period " +
            formatDate(
              this.HREmp.employeeSalaryAdvances[k].FromMonth,
              "MMM-yy",
              "en_US"
            ) +
            " to " +
            formatDate(
              this.HREmp.employeeSalaryAdvances[k].ToMonth,
              "MMM-yy",
              "en_US"
            )
          );
          return;
        }
        for (var j = 0; j < this.HREmp.employeeSalaryAdvances[k].employeeSalaryAdvanceDetails.length; j++) {






          this.HREmp.employeeSalaryAdvances[k].employeeSalaryAdvanceDetails[j].EmpCode = this.HREmp.employeeSalaryAdvances[k].employeeSalaryAdvanceDetails[j].EmpCode > 0




            ? this.HREmp.employeeSalaryAdvances[k].employeeSalaryAdvanceDetails[j].EmpCode : this.EmpCode;


          this.HREmp.employeeSalaryAdvances[k].employeeSalaryAdvanceDetails[
            j
          ].CreatedBy =
            this.HREmp.employeeSalaryAdvances[k].employeeSalaryAdvanceDetails[j]
              .CreatedBy != null
              ? this.HREmp.employeeSalaryAdvances[k]
                .employeeSalaryAdvanceDetails[j].CreatedBy
              : this.EmpCode.toString();
          this.HREmp.employeeSalaryAdvances[k].employeeSalaryAdvanceDetails[
            j
          ].ModifiedBy =
            this.HREmp.employeeSalaryAdvances[k].employeeSalaryAdvanceDetails[j]
              .ModifiedBy != null
              ? this.HREmp.employeeSalaryAdvances[k]
                .employeeSalaryAdvanceDetails[j].ModifiedBy
              : this.EmpCode.toString();
          if (
            this.HREmp.employeeSalaryAdvances[k].employeeSalaryAdvanceDetails[j]
              .Amount == null
          ) {
            this.toastr.warning("Please fill required fields ");
            return;
          }
          if (
            this.HREmp.employeeSalaryAdvances[k].employeeSalaryAdvanceDetails[j]
              .Amount == 0
          ) {
            this.toastr.warning(
              "Amount must be greater than 0 for " +
              this.HREmp.employeeSalaryAdvances[k]
                .employeeSalaryAdvanceDetails[j].Month +
              " (Period:" +
              formatDate(
                this.HREmp.employeeSalaryAdvances[k].FromMonth,
                "MMM-yy",
                "en_US") + " to " + formatDate(this.HREmp.employeeSalaryAdvances[k].ToMonth, "MMM-yy", "en_US") + ")");
            return;
          }
          count += Number(
            this.HREmp.employeeSalaryAdvances[k].employeeSalaryAdvanceDetails[j]
              .Amount
          );
        }
        if (
          count != 0 &&
          count != this.HREmp.employeeSalaryAdvances[k].Amount

        ) {
          this.toastr.warning(
            "Salary Advance Amount doesn't match for the period " +



            formatDate(
              this.HREmp.employeeSalaryAdvances[k].FromMonth,
              "MMM-yy",
              "en_US"
            ) +
            " to " +
            formatDate(
              this.HREmp.employeeSalaryAdvances[k].ToMonth,
              "MMM-yy",
              "en_US"
            )

          );
          return;
        }
        if (

























          this.HREmp.employeeSalaryAdvances != null &&
          this.HREmp.employeeSalaryAdvances.length > 0
        ) {
          var count = 0;
          for (var i = 0; i < this.HREmp.employeeSalaryAdvances.length; i++) {
            if (
              !isNullOrUndefined(this.HREmp.employeeSalaryAdvances[i].FromMonth)
            ) {
              this.HREmp.employeeSalaryAdvances[i].FromMonth = formatDate(
                new Date(this.HREmp.employeeSalaryAdvances[i].FromMonth),
                "yyyy-MM-dd",
                "en_US"
              );
            }
            if (
              !isNullOrUndefined(this.HREmp.employeeSalaryAdvances[i].ToMonth)
            ) {
              this.HREmp.employeeSalaryAdvances[i].ToMonth = formatDate(
                new Date(this.HREmp.employeeSalaryAdvances[i].ToMonth),
                "yyyy-MM-dd",
                "en_US"
              );
            }
          }
        }
      }

    }
    if (
      this.HREmp.employeeCarLeases != null &&
      this.HREmp.employeeCarLeases.length > 0
    ) {
      for (var i = 0; i < this.HREmp.employeeCarLeases.length; i++) {
        if (!isNullOrUndefined(this.HREmp.employeeCarLeases[i].PayOutDate)) {
          this.HREmp.employeeCarLeases[i].PayOutDate = new Date(
            this.datePipe.transform(
              this.HREmp.employeeCarLeases[i].PayOutDate,
              this.config.dateFormat()
            )
          );
        }

        this.HREmp.employeeCarLeases[i].EmpCode =
          this.HREmp.employeeCarLeases[i].EmpCode > 0
            ? this.HREmp.employeeCarLeases[i].EmpCode
            : this.EmpCode;
        this.HREmp.employeeCarLeases[i].CreatedBy =
          this.HREmp.employeeCarLeases[i].CreatedBy != null
            ? this.HREmp.employeeCarLeases[i].CreatedBy
            : this.EmpCode.toString();
        this.HREmp.employeeCarLeases[i].ModifiedBy =
          this.HREmp.employeeCarLeases[i].ModifiedBy != null
            ? this.HREmp.employeeCarLeases[i].ModifiedBy
            : this.EmpCode.toString();
        const fromMonth = new Date(this.HREmp.employeeCarLeases[i].FromMonth);
        const toMonth = new Date(this.HREmp.employeeCarLeases[i].ToMonth);
        if (
          fromMonth.getFullYear() > toMonth.getFullYear() ||
          (fromMonth.getFullYear() === toMonth.getFullYear() &&
            fromMonth.getMonth() > toMonth.getMonth())
        ) {
          this.toastr.warning(
            "Car Lease End Month cannot be earlier than the Start Month for the record " +
            formatDate(
              this.HREmp.employeeCarLeases[i].FromMonth,
              "MMM-yy",
              "en_US"
            ) +
            " to " +
            formatDate(
              this.HREmp.employeeCarLeases[i].ToMonth,
              "MMM-yy",
              "en_US"
            )
          );
          return;
        }
        if (
          this.HREmp.employeeCarLeases[i].FromMonth == null ||
          this.HREmp.employeeCarLeases[i].ToMonth == null ||
          this.HREmp.employeeCarLeases[i].PayOutDate == null ||
          this.HREmp.employeeCarLeases[i].Amount == null
        ) {
          this.toastr.warning("Please fill required fields ");
          return;
        }
        if (this.HREmp.employeeCarLeases[i].Amount == 0) {
          this.toastr.warning(
            "Car Lease Advance Amount must be greater than 0 for the period " +
            formatDate(
              this.HREmp.employeeCarLeases[i].FromMonth,
              "MMM-yy",
              "en_US"
            ) +
            " to " +
            formatDate(
              this.HREmp.employeeCarLeases[i].ToMonth,
              "MMM-yy",
              "en_US"
            )
          );
          return;
        }
        for (
          var j = 0;
          j < this.HREmp.employeeCarLeases[i].employeeCarLeaseDetails.length;
          j++
        ) {
          this.HREmp.employeeCarLeases[i].employeeCarLeaseDetails[j].EmpCode =
            this.HREmp.employeeCarLeases[i].employeeCarLeaseDetails[j].EmpCode >
              0
              ? this.HREmp.employeeCarLeases[i].employeeCarLeaseDetails[j]
                .EmpCode
              : this.EmpCode;
          this.HREmp.employeeCarLeases[i].employeeCarLeaseDetails[
            j
          ].SalaryAdvanceId =
            this.HREmp.employeeCarLeases[i].Id > 0
              ? this.HREmp.employeeCarLeases[i].Id
              : this.HREmp.employeeCarLeases[i].employeeCarLeaseDetails[j]
                .SalaryAdvanceId;
          this.HREmp.employeeCarLeases[i].employeeCarLeaseDetails[j].CreatedBy =
            this.HREmp.employeeCarLeases[i].employeeCarLeaseDetails[j]
              .CreatedBy != null
              ? this.HREmp.employeeCarLeases[i].employeeCarLeaseDetails[j]
                .CreatedBy
              : this.EmpCode.toString();
          this.HREmp.employeeCarLeases[i].employeeCarLeaseDetails[
            j
          ].ModifiedBy =
            this.HREmp.employeeCarLeases[i].employeeCarLeaseDetails[j]
              .ModifiedBy != null
              ? this.HREmp.employeeCarLeases[i].employeeCarLeaseDetails[j]
                .ModifiedBy
              : this.EmpCode.toString();
          if (
            this.HREmp.employeeCarLeases[i].employeeCarLeaseDetails[j].Amount ==
            null
          ) {
            this.toastr.warning("Please fill required fields ");
            return;
          }
          if (
            this.HREmp.employeeCarLeases[i].employeeCarLeaseDetails[j].Amount ==
            0
          ) {
            this.toastr.warning(
              "Amount cannot be 0 for " +
              this.HREmp.employeeCarLeases[i].employeeCarLeaseDetails[j]
                .Month +
              " for (Period:" +
              formatDate(
                this.HREmp.employeeCarLeases[i].FromMonth,
                "MMM-yy",
                "en_US"
              ) +
              " to " +
              formatDate(
                this.HREmp.employeeCarLeases[i].ToMonth,
                "MMM-yy",
                "en_US"
              ) +
              ")"
            );
            return;
          }
        }
        if (!isNullOrUndefined(this.HREmp.employeeCarLeases[i].FromMonth)) {
          this.HREmp.employeeCarLeases[i].FromMonth = this.datePipe.transform(
            this.HREmp.employeeCarLeases[i].FromMonth,
            this.config.dateFormat()
          );
        }
        if (!isNullOrUndefined(this.HREmp.employeeCarLeases[i].ToMonth)) {
          this.HREmp.employeeCarLeases[i].ToMonth = this.datePipe.transform(
            this.HREmp.employeeCarLeases[i].ToMonth,
            this.config.dateFormat()
          );
        }
      }
    }
    return this.HREmp;
  }

  getRefreshPage() {
    window.location.reload();
  }

  // doEmpFilter(searchTerm) {
  //   if (!searchTerm) {
  //     this.filteredEmpList = this.empList;
  //   } else {
  //     if (!isNullOrUndefined(this.RecruiterId)) {
  //       this.filteredEmpList = this.empList.filter(
  //         (emp) =>
  //           emp.FirstName.toLowerCase().includes(searchTerm) ||
  //           emp.EmpCode.toString().toLowerCase().includes(searchTerm)
  //       );
  //     }
  //   }
  // }

  get f() {
    return this.hrdetailsform.controls;
  }

  getDesignations() {
    this.hrSvc.getDesignations().subscribe((data: any) => {
      this.Required = true;
      this.designationsList = data;
      this.filteredList = this.designationsList;
    });
  }

  getJobSources() {
    this.hrSvc.getJobSources().subscribe((data: any) => {
      this.jobsources = data;
    });
  }

  //getJobPlatform(Id) {
  //  this.hrSvc.getJobPlatforms(Id).subscribe(
  //    (data: any) => {
  //      this.jobPlatform = data;
  //      this.isLoader = false;
  //    },
  //    (error) => {
  //      this.isLoader = false;
  //      this.error = error;
  //    }
  //  );
  //}

  getJobPlatform(Id): Promise<void> {
    return new Promise((resolve, reject) => {
      this.hrSvc.getJobPlatforms(Id).subscribe(
        (data: any) => {
          this.jobPlatform = data;
          this.isLoader = false;
          const selectedPlatform = this.jobPlatform.find(
            (platform) => platform.Name === this.HREmp.ProfileSourceCategoryOne
          );
          if (selectedPlatform) {
            this.HREmp.ProfileSourceCategoryOne = selectedPlatform.Id;
          }
          resolve();  // Resolve when done
        },
        (error) => {
          this.isLoader = false;
          this.error = error;
          reject(error);  // Reject if there's an error
        }
      );
    });
  }

  //getJobPlatform(Id) {
  //  this.hrSvc.getJobPlatforms(Id).subscribe(
  //    (data: any) => {
  //      this.jobPlatform = data;
  //      this.isLoader = false;
  //      const selectedPlatform = this.jobPlatform.find(
  //        (platform) => platform.Name === this.HREmp.ProfileSourceCategoryOne
  //      )
  //      if (selectedPlatform) {
  //        this.HREmp.ProfileSourceCategoryOne = selectedPlatform.Id;
  //      }
  //    },
  //    (error) => {
  //      this.isLoader = false;
  //      this.error = error;
  //    }
  //  );
  //}


  mouseEnter() {
    this.iconVisible = true;
  }

  mouseLeave() {
    this.iconVisible = false;
  }

  showNewHikeConfirmationDialog() {
    // const message = `Please confirm if you want to trigger new hike?`;
    // const dialogData = new ConfirmDialogModel(" ", message, "Submit");
    // const dialogRef = this.dialog.open(ConfirmDialogComponent, {
    //   maxWidth: "400px",
    //   data: dialogData,
    // });
    // dialogRef.afterClosed().subscribe(
    //   (dialogResult) => {
    //     if (dialogResult) {
    const orgData = this.HREmp.employeeBonusDetailsList;
    const isNewColumSaved = orgData.filter(({ isNew }) => isNew === true);
    if (isNewColumSaved && isNewColumSaved.length > 0) {
      this.toastr.warning("Before adding a new one, save the current changes.");
    } else {
      this.addNewHikeRow();
    }
    //     }
    //   },
    //   (error) => {
    //     this.result = error;
    //   }
    // );
  }

  addNewCtcCmp() {
    if (this.bonusOptions && this.bonusOptions.length > 0) {
      const allKeys = [];
      if (this.bonusOptions.length > 0) {
        this.bonusOptions.map((item) => {
          allKeys.push(item.Name);
        });
      }
      const orgArray = [...new Set(allKeys)];
      const stringsToExclude = [
        "EmpCode",
        ...this.mainCmp,
        ...this.bonusCmp,
        ...this.staticCmp,
        ...this.offerCmp,
      ];
      const newArrayCtcCmp = this.bonusOptions
        .filter(({ IsCTC, Name }) => IsCTC && !stringsToExclude.includes(Name))
        .map(({ Name }) => Name);
      const newArrayBonusCmp = this.bonusOptions
        .filter(({ IsCTC, Name }) => !IsCTC && !stringsToExclude.includes(Name))
        .map(({ Name }) => Name);
      this.newlyAddedCtcCmp = newArrayCtcCmp;
      this.newlyAddedBonusCmp = newArrayBonusCmp;
      this.CTCComponentsList = [
        ...this.mainCmp,
        ...newArrayCtcCmp,
        "ADD",
        "CTC",
        ...this.bonusCmp,
        ...this.newlyAddedBonusCmp,
        "ADDBonus",
        ...this.staticCmp,
        ...this.offerCmp,
      ];
      this.allCmpCount = [...this.mainCmp, ...newArrayCtcCmp].length;
    }
  }

  addNewHikeRow() {
    if (this.HREmp.employeeBonusDetailsList.length > 0) {
      const orgList = JSON.stringify(this.HREmp.employeeBonusDetailsList);
      let list = this.HREmp.employeeBonusDetailsList;
      list = list.reverse();
      let effectiveDate;
      if (list.length > 0) {
        const currentDate = moment(list[list.length - 1].EffectiveDate);
        const newDate = currentDate.add(1, 'days');
        effectiveDate = newDate;
      } else {
        effectiveDate = new Date();
      }

      const addNew = {
        isNew: true,
        EffectiveDate: effectiveDate,
        FixedCTC: "",
        IPA: "",
        CPA: "",
        "Performance Bonus": "",
        "Retention Bonus": "",
        "Variable Pay": "",
        ADD: "",
        CTC: "",
        "Stretch Bonus": "",
        JoiningBonus: "",
        "Long Term Bonus": "",
        RelocationEligibility: "null",
        minDate: effectiveDate,
      };

      this.HREmp.employeeBonusDetailsList = [addNew, ...JSON.parse(orgList)];
      if (this.HREmp.employeeBonusDetailsList.length > 0) {
        let finalDataArr = this.HREmp.employeeBonusDetailsList;
        finalDataArr.map((item, index) => {
          if (item.isNew !== true) {
            this.ctcCalculationFun(item, index);
          }
        });
      }
    }
  }

  deleteHikeRow(j) {
    const message = `Please confirm if you want to delete this section?`;
    const dialogData = new ConfirmDialogModel(" ", message, "Submit");
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          const mainArr = this.HREmp.employeeBonusDetailsList;
          const finalData = mainArr.filter((e, i) => i !== j);
          this.HREmp.employeeBonusDetailsList = [...finalData];
          this.toastr.error("Deleted selected data successfully!");
        }
      },
      (error) => {
        this.result = error;
      }
    );
  }

  decryptAES(encryptedData, privateKeyBase64: string) {
    try {
      let cipherPhrase = privateKeyBase64;

      var key = CryptoJS.enc.Utf8.parse(cipherPhrase);
      var iv = CryptoJS.enc.Utf8.parse("");

      var decrypted = CryptoJS.AES.decrypt(encryptedData.trim(), key, {
        keySize: 128 / 8,
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });

      return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8));
    } catch (e) { }
  }

  async getData() {
    const bonusListControl = this.hrdetailsform.get(
      "bonusDetails"
    ) as FormArray;
    bonusListControl.clear();
    const data: any = await this.hrSvc
      .getEmployeebyCodeHrDetails(this.EmpCode).toPromise();

    await this.getBonusList();

    this.HREmp = data;
    if (this.HREmp == null) {
      this.HREmp = new HRempHiringDetails();
      this.HREmp.JoiningBonus = "0";
      this.HREmp.employeeBonusDetailsList = [];
      this.isLoader = false;
    }

    if (this.HREmp != null) {
      if (
        this.HREmp.employeeBonusDetailsList != null &&
        this.HREmp.employeeBonusDetailsList.length > 0
      ) {
        this.encryptedData = this.HREmp.employeeBonusDetailsList;
        const decryptedData = this.encryptedData.map((obj, idx) => {
          Object.entries(obj).forEach(([key, value]) => {
            obj[key] =
              key === "RelocationEligibility"
                ? value
                : key === "EffectiveDate"
                  ? value
                  : key === "EmpCode"
                    ? value
                    : key === "EmpId"
                      ? value
                      : key === "OfferLetterDocumentName"
                        ? value
                        : key === "OfferLetterDocumentPath"
                          ? value
                          : key === "JoiningBonus"
                            ? value
                            : this.decryptAES(value, this.privateKeyBase64);
          });
          return obj;
        });

        this.HREmp.employeeBonusDetailsList = decryptedData;
        this.originalGetData = JSON.stringify(
          this.HREmp.employeeBonusDetailsList
        );
        localStorage.setItem("compentAndBenifits", this.originalGetData);
      }

      if (this.HREmp) {
        const allKeys = [];
        if (this.bonusOptions != null && this.bonusOptions.length > 0) {
          this.bonusOptions.map((item) => {
            allKeys.push(item.Name);
          });
        }
        const orgArray = [...new Set(allKeys)];
        const stringsToExclude = [
          "EmpCode",
          ...this.mainCmp,
          ...this.bonusCmp,
          ...this.staticCmp,
          ...this.offerCmp,
        ];
        const newArrayCtcCmp = this.bonusOptions
          .filter(
            ({ IsCTC, Name }) => IsCTC && !stringsToExclude.includes(Name)
          )
          .map(({ Name }) => Name);
        const newArrayBonusCmp = this.bonusOptions
          .filter(
            ({ IsCTC, Name }) => !IsCTC && !stringsToExclude.includes(Name)
          )
          .map(({ Name }) => Name);
        this.newlyAddedCtcCmp = newArrayCtcCmp;
        this.newlyAddedBonusCmp = newArrayBonusCmp;
        this.CTCComponentsList = [
          ...this.mainCmp,
          ...newArrayCtcCmp,
          "ADD",
          "CTC",
          ...this.bonusCmp,
          ...this.newlyAddedBonusCmp,
          "ADDBonus",
          ...this.staticCmp,
          ...this.offerCmp,
        ];
        this.allCmpCount = [...this.mainCmp, ...newArrayCtcCmp].length;
      }

      if (this.HREmp.employeeBonusDetailsList.length === 0) {
        this.HREmp.employeeBonusDetailsList = [
          {
            isNew: true,
            EffectiveDate: new Date(),
            FixedCTC: "",
            IPA: "",
            CPA: "",
            "Performance Bonus": "",
            "Retention Bonus": "",
            "Variable Pay": "",
            ADD: "",
            CTC: "",
            "Stretch Bonus": "",
            JoiningBonus: "",
            "Long Term Bonus": "",
            RelocationEligibility: "",
          },
        ];
      }


      if (this.HREmp.ProfileSource) {

        const selectedJobSource = this.jobsources.find(({ Name }) => Name === this.HREmp.ProfileSource);
        if (selectedJobSource) {
          const selectedId = selectedJobSource.Id;
          await this.getJobPlatform(selectedId);
        }




      }

      this.HREmp.ProfileSource =
        this.HREmp.ProfileSource == null
          ? "None"
          : this.HREmp.ProfileSource;
      this.HREmp.ProfileSourceCategoryOne =
        this.HREmp.ProfileSourceCategoryOne == null
          ? "None"
          : this.HREmp.ProfileSourceCategoryOne;
      this.HREmp.ProfileSourceCategoryTwo =
        this.HREmp.ProfileSourceCategoryTwo == null
          ? null
          : this.HREmp.ProfileSourceCategoryTwo;
      this.HREmp.RecruiterDesignationId =
        this.HREmp.RecruiterDesignationId == null
          ? null
          : this.HREmp.RecruiterDesignationId;
      this.HREmp.RecruiterId =
        this.HREmp.RecruiterId == null ? null : this.HREmp.RecruiterId;
      // if (this.HREmp.employeeBonusDetails.length > 0) {
      //   this.zone.runOutsideAngular(() => {
      //     this.HREmp.employeeBonusDetails.forEach((item, index) => {
      //       this.onSelectionChange(index, item.Name);
      //       this.addItem(item);
      //     });
      //   });
      // }

      if (this.HREmp.employeeBonusDetailsList.length > 0) {
        let finalDataArr = this.HREmp.employeeBonusDetailsList;
        finalDataArr.map((item, index) => {
          this.ctcCalculationFun(item, index);
        });
      }

      if (
        this.HREmp.employeeSalaryAdvances != null &&
        this.HREmp.employeeSalaryAdvances.length > 0
      ) {
        for (var i = 0; i < this.HREmp.employeeSalaryAdvances.length; i++) {
          var salaryAdvance = this.HREmp.employeeSalaryAdvances[i];
          this.setMonth(i, salaryAdvance.FromMonth, salaryAdvance.ToMonth);
          this.empList.forEach((item) => {
            if (item.EmpCode == salaryAdvance.ApproverCode) {
              this.salaryAdvanceApprvrId[i] = item.recDisplayName;
            }
          });
        }
      }
      if (
        this.HREmp.employeeCarLeases != null &&
        this.HREmp.employeeCarLeases.length > 0
      ) {
        for (var i = 0; i < this.HREmp.employeeCarLeases.length; i++) {
          var carLease = this.HREmp.employeeCarLeases[i];
          this.setCarLeaseMonth(i, carLease.FromMonth, carLease.ToMonth);
        }
      }

      this.HREmp.JoiningBonus =
        this.HREmp.JoiningBonus == null ? "0" : this.HREmp.JoiningBonus;
      var others = this.hrdetailsform.get("ProfileSourceCategoryTwo");
      if (
        this.HREmp.ProfileSource != null &&
        this.HREmp.ProfileSource != "" &&
        this.HREmp.ProfileSource != "Social Network" &&
        this.HREmp.ProfileSource != "Career Portal" &&
        this.HREmp.ProfileSource != "Job Board" &&
        this.HREmp.ProfileSource != "Direct re-hire"
      ) {
        this.showOtherControl = true;
      } else if (
        this.HREmp.ProfileSource != null &&
        this.HREmp.ProfileSource != ""
      ) {
        this.showOtherControl = false;
      }
      const recruiter = this.empList != null ? this.empList.find(item => item.EmpCode === this.HREmp.RecruiterId) : null;

      if (recruiter) {
        this.RecruiterId = recruiter.recDisplayName;
        this.RecruiterDesignation = recruiter.DesignationName;
      }


      this.originalHiringDetails = JSON.parse(JSON.stringify(this.HREmp));


      this.isLoader = false;
      if (!this.destroyed) this.cdr.detectChanges();
    }
    // this.isLoader = false;
    //setTimeout(() => {
    //  this.isLoader = false;
    //}, 1000);
    // });
  }

  //onSelectionChange(index: number, selectedValue: any) {
  //  const selectedValues = this.bonusDetails.controls.map((group) => group.get('Name').value);

  //  if (selectedValues.filter(value => value === selectedValue).length > 1) {
  //    alert('This value has already been selected. Please choose a different one.');

  //    this.bonusDetails.at(index).get('Name').setValue('');
  //  }
  //}

  getBonusList() {
    return new Promise((resolve, reject) => {
      this.emp_Svc.getEmpBonus().subscribe(
        (data: any) => {
          this.bonusOptions = data;
          resolve(this.bonusOptions);
        },
        (error) => reject(error)


      );
    });
  }

  addCompensation(val) {
    const dialogData = new BonusDialog("Action", val);
    const dialogRef = this.dialog.open(CompensationDialogComponent, {
      width: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.getBonusList();
          setTimeout(() => {
            // const bonusDetailGroup = this.bonusDetails.at(i);
            const res = this.bonusOptions.filter((b) => {
              return b.Name === dialogResult.Name;
            });
            if (res.length === 1) {
              this.addNewCtcCmp();
            } else {
            }
          }, 500);
        }
      },
      (error) => {
        this.error = error;
      }
    );
  }

  getCadreData() {
    this.hrSvc.getEmployeebyId(this.EmpCode).subscribe((data: any) => {
      this.HREmp = data;
      // this.cadresList.forEach((item) => {
      //   if (item.ID == this.HREmp.CadreId) {
      //     this.cadreId = item.CadreName;
      //   }
      // });
      //if (this.HREmp && this.HREmp.EmpEmailId != null) {
      //  this.hrdetailsform.get("emailId").disable();
      //}
    });
  }

  getDepartments() {
    this.deptSvc.getDepartments().subscribe((data: any) => {
      this.departmentsList = data;
    });
  }

  getCadres() {
    this.cadreSvc.getCadres().subscribe((data: any) => {
      this.cadresList = data;
    });
  }

  getAllEmplist() {
    this.employeelist = [];
    this.onboardsvc.getEmpList().subscribe(
      (data: OnboardingHRDetail[]) => {
        this.employeelist = data;
        if (isNullOrUndefined(this.EmpCode)) {
          this.isLoader = false;
        }
      },
      (error) => (this.error = error)
    );
  }

  getEmployeeList(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.emp_Svc.getAllActiveEmployees().subscribe(
        (data: any[]) => {
          const tempList = [];
          this.empList = data;
          this.empList.forEach((el) => {
            let item = el;
            item.recDisplayName = el.FirstName + " - " + el.EmpCode;
            item.recEmpCode = el.EmpCode;
            tempList.push(item);
          });
          this.empList = tempList;
          this.filteredEmpList = this.empList;
          this.filteredSalaryAdvanceEmpList = this.empList;

          resolve(this.empList);  // Resolve the promise after the data is loaded
        },
        (error) => reject(error)  // Reject if there's an error
      );
    });
  }

  //getEmployeeList() {
  //  this.emp_Svc.getAllActiveEmployees().subscribe(
  //    (data: any[]) => {
  //      const tempList = [];
  //      this.empList = data;
  //      this.empList.forEach((el) => {
  //        let item = el;
  //        item.recDisplayName = el.FirstName + " - " + el.EmpCode;
  //        item.recEmpCode = el.EmpCode;
  //        tempList.push(item);
  //      });
  //      this.empList = tempList;
  //      this.filteredEmpList = this.empList;
  //      this.filteredSalaryAdvanceEmpList = this.empList;
  //    },
  //    (error) => (this.error = error)
  //  );
  //}

  filterRecList(values, recr) {
    return values.filter((value) =>
      value.recDisplayName.toLowerCase().includes(recr.toLowerCase())
    );
  }

  doEmpFilter(searchTerm) {
    if (!searchTerm) {
      this.filteredEmpList = this.empList;
    } else {
      if (!isNullOrUndefined(searchTerm)) {
        this.filteredEmpList = this.filterRecList(this.empList, searchTerm);
      }

      // if (!isNullOrUndefined(this.RecruiterId)) {
      //   this.filteredEmpList = this.empList.filter(
      //     (emp) =>
      //       emp.FirstName.toLowerCase().includes(searchTerm) ||
      //       emp.EmpCode.toString().toLowerCase().includes(searchTerm)
      //   );
      // }
    }
  }

  onSalaryAdvanceEmpSelectionChanged(event, index) {
    this.HREmp.employeeSalaryAdvances[index].ApproverCode = event.option.id;
  }

  doSalaryAdvanceEmpFilter(searchTerm) {
    if (!searchTerm) {
      this.filteredSalaryAdvanceEmpList = this.empList;
    } else {
      if (!isNullOrUndefined(searchTerm)) {
        this.filteredSalaryAdvanceEmpList = this.filterRecList(
          this.empList,
          searchTerm
        );
      }
    }
  }

  async Reset() {
    this.hrdetailsform.reset();
    await this.getEmployeeList();
    this.getData();
    this.getJobSources();
    this.getAllEmplist();
    this.setRecruiterDesignation();
  }

  addJobSource() {
    const message = `Add New JobSource`;
    const dialogData = new ProfilesourceDialog(
      "jobSource",
      "Action",
      message,
      null
    );
    const dialogRef = this.dialog.open(ProfilesourceDialogComponent, {
      width: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.getJobSources();
          this.HREmp.ProfileSource = dialogResult.Name;
          this.selectedProfileSource = dialogResult.Name;
          this.showOtherControl = true;
          setTimeout(() => {
            const selectedId = this.jobsources.find(
              ({ Name }) => Name === this.HREmp.ProfileSource
            ).Id;
            this.getJobPlatform(selectedId);
          }, 500);
        }
      },
      (error) => {
        this.error = error;
      }
    );
    if (!this.destroyed) this.cdr.detectChanges();
  }

  addJobPlatform() {
    const message = `Add New Sub-category`;
    const dialogData = new ProfilesourceDialog(
      "jobPlatform",
      "Action",
      message,
      this.selectedProfileSource
    );
    const dialogRef = this.dialog.open(ProfilesourceDialogComponent, {
      width: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.getJobSources();
          this.HREmp.ProfileSourceCategoryOne = dialogResult.Name;
          this.Required = false;
          setTimeout(() => {
            const selectedId = this.jobsources.find(
              ({ Name }) => Name === this.HREmp.ProfileSource
            ).Id;
            this.getJobPlatform(selectedId);
          }, 1000);
        }
      },
      (error) => {
        this.error = error;
      }
    );
  }

  handleInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const value = input.value;

    // Perform conditional logic based on ProfileSource
    if (
      this.HREmp.ProfileSource === "Vendor" ||
      this.HREmp.ProfileSource === "Referral" ||
      this.HREmp.ProfileSource === "RPO"
    ) {
      input.value = value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");
    }
  }

  onSelectionChangeProfileSource(event) {
    this.selectedProfileSource = event.value || event!.option!.id;
    this.oldJobSource =
      this.oldJobSource == null ? event.value : this.oldJobSource;
    const selectedId = this.jobsources.find(
      ({ Name }) => Name === this.selectedProfileSource
    ).Id;
    if (event.value != null && event.value != this.oldJobSource) {
      this.HREmp.ProfileSourceCategoryOne = null;
      this.HREmp.ProfileSourceCategoryTwo = null;
    }
    if (
      this.selectedProfileSource != null &&
      this.HREmp.ProfileSource != "Career Portal"
    ) {
      this.getJobPlatform(selectedId);
      this.HREmp.ProfileSourceCategoryTwo = null;
    }
    if (
      this.selectedProfileSource != null &&
      this.HREmp.ProfileSource == "Career Portal"
    ) {
      this.HREmp.ProfileSourceCategoryOne = "None";
    }
    if (
      this.selectedProfileSource != null &&
      this.HREmp.ProfileSource == "Direct re-hire"
    ) {
      this.HREmp.ProfileSourceCategoryOne = "None";
    }
    this.oldJobSource = event.value;

    var others = this.hrdetailsform.get("ProfileSourceCategoryTwo");
    if (
      this.HREmp.ProfileSource != null &&
      this.HREmp.ProfileSource != "" &&
      this.HREmp.ProfileSource != "Social Network" &&
      this.HREmp.ProfileSource != "Career Portal" &&
      this.HREmp.ProfileSource != "Job Board" &&
      this.HREmp.ProfileSource != "Direct re-hire"
    ) {
      others.setValue(null);
      this.HREmp.ProfileSourceCategoryTwo = null;
      others.clearValidators();
      this.showOtherControl = true;
    } else if (
      this.HREmp.ProfileSource != null &&
      this.HREmp.ProfileSource != ""
    ) {
      this.showOtherControl = false;
    }
    if (
      (!isNullOrUndefined(this.selectedProfileSource) &&
        this.HREmp.ProfileSource == "Vendor") ||
      this.HREmp.ProfileSource == "Referral" ||
      this.HREmp.ProfileSource == "RPO"
    ) {
      others.setValidators([Validators.required]);
    } else {
      others.clearValidators();
      others.updateValueAndValidity();
    }
    if (!this.destroyed) this.cdr.detectChanges();
  }

  //onEmpSelectionChanged(event) {
  //  this.HREmp.RecruiterId = event.option.id;
  //  this.HREmp.RecruiterDesignationId =
  //    this.empList.filter((emp) => this.HREmp.RecruiterId == emp.EmpCode)
  //      .length > 0
  //      ? this.empList.filter((emp) => this.HREmp.RecruiterId == emp.EmpCode)[0]
  //          .DesignationId
  //      : null;
  //  this.RecruiterDesignation =
  //    this.designationsList.filter(
  //      (desg) => desg.ID == this.HREmp.RecruiterDesignationId
  //    ).length > 0
  //      ? this.designationsList.filter(
  //          (desg) => desg.ID == this.HREmp.RecruiterDesignationId
  //        )[0].DesignationName
  //      : null;
  //  this.hrdetailsform
  //    .get("RecruiterDesignationId")
  //    .setValue(this.RecruiterDesignation);
  //}
  onEmpSelectionChanged(event) {
    this.HREmp.RecruiterId = event.option.id;
    const recruiter = this.empList.find(
      (emp) => this.HREmp.RecruiterId == emp.EmpCode
    );
    if (recruiter) {
      this.HREmp.RecruiterDesignationId = recruiter.DesignationId;
      this.RecruiterDesignation = recruiter.DesignationName;
      this.hrdetailsform
        .get("RecruiterDesignationId")
        .setValue(this.RecruiterDesignation);
    }
  }

  setRecruiterDesignation() {
    if (this.HREmp.RecruiterId != null) {
      const recruiter = this.empList.find(
        (emp) => this.HREmp.RecruiterId == emp.EmpCode
      );
      if (recruiter) {
        this.HREmp.RecruiterDesignationId = recruiter.DesignationId;
        this.RecruiterDesignation = recruiter.DesignationName;
        this.hrdetailsform
          .get("RecruiterDesignationId")
          .setValue(this.RecruiterDesignation);
      }
    }
  }

  ChangeDesignation() {
    const message = `Add New Designation`;

    const dialogData = new DesignationDialog("Action", message);
    const dialogRef = this.dialog.open(DesignationDialogComponent, {
      width: "400px",
      data: dialogData,
    });
    dialogRef.afterClosed().subscribe(
      (dialogResult) => {
        if (dialogResult) {
          this.getDesignations();
          this.designationId = dialogResult.DesignationName;
          this.Required = false;
        }
      },
      (error) => {
        this.error = error;
      }
    );
  }

  doFilter() {
    if (!isNullOrUndefined(this.designationId)) {
      this.filteredList = this.filter(this.designationsList);
    }
  }

  onSelectionChange(index: number, selectedValue: string) {
    this.selectedBonusOptions[index] = selectedValue;
  }

  getFilteredBonusOptions(index: number) {
    return this.bonusOptions.filter(
      (option) =>
        !this.selectedBonusOptions.includes(option.Name) ||
        this.selectedBonusOptions[index] === option.Name
    );
  }

  filter(values) {
    return values.filter((value) =>
      value.DesignationName.toLowerCase().includes(
        this.designationId.toLowerCase()
      )
    );
    // return values.filter((value) =>
    //   value.FirstName.toLowerCase().includes(this.NominatedBy.toLowerCase())
    // );
  }
  Cancel() {
    this.router.navigateByUrl("/employeelist");
  }

  //Custom validation for Designation(Mat autocomplete) to validate user text with designations list
  //Returns true if user text is not found in designation list
  private requireMatch(control: FormControl): ValidationErrors | null {
    const selection: any = control.value;
    let match = null;
    if (!isNullOrUndefined(selection) && selection != "") {
      if (this.Required == true) {
        if (!isNullOrUndefined(this.designationsList)) {
          for (var i = 0; i < this.designationsList.length; i++) {
            if (this.designationsList[i].DesignationName == selection) {
              match = null;
              break;
            } else {
              match = true;
            }
          }
          if (match == true) {
            return { requireMatch: match };
          }
        }
      }
    } else {
      return null;
    }
  }

  private requireMatchDept(control: FormControl): ValidationErrors | null {
    const selectionDept: any = control.value;
    let match = null;
    if (!isNullOrUndefined(selectionDept) && selectionDept != "") {
      if (this.RequiredDept == true) {
        if (!isNullOrUndefined(this.departmentsList)) {
          for (var i = 0; i < this.departmentsList.length; i++) {
            if (this.departmentsList[i].DepartmentName == selectionDept) {
              match = null;
              break;
            } else {
              match = true;
            }
          }
          if (match == true) {
            return { requireMatchDept: match };
          }
        }
      }
    } else {
      return null;
    }
  }
  private requireMatchProfileSource(
    control: FormControl
  ): ValidationErrors | null {
    const selectionProfileSource: any = control.value;
    let match = null;
    if (
      !isNullOrUndefined(selectionProfileSource) &&
      selectionProfileSource != ""
    ) {
      if (this.RequiredCadre == true) {
        if (!isNullOrUndefined(this.jobsources)) {
          for (var i = 0; i < this.jobsources.length; i++) {
            if (this.jobsources[i].Name == selectionProfileSource) {
              match = null;
              break;
            } else {
              match = true;
            }
          }
          if (match == true) {
            return { requireMatchProfileSource: match };
          }
        }
      }
    } else {
      return null;
    }
  }

  private requireMatchRecruiterId(
    control: FormControl
  ): ValidationErrors | null {
    const selectionRecruiterId: any = control.value;
    let match = null;
    if (
      !isNullOrUndefined(selectionRecruiterId) &&
      selectionRecruiterId != ""
    ) {
      if (!isNullOrUndefined(this.filteredEmpList)) {
        for (var i = 0; i < this.filteredEmpList.length; i++) {
          if (this.filteredEmpList[i].recDisplayName == selectionRecruiterId) {
            match = null;
            break;
          } else {
            match = true;
          }
        }
        if (match == true) {
          return { requireMatchRecruiterId: match };
        }
      }
    } else {
      return null;
    }
  }

  private requireMatchApproverID(
    index,
    control: FormControl
  ): ValidationErrors | null {
    const selectedApproverId: any = control.value;
    let match = null;
    if (!isNullOrUndefined(selectedApproverId) && selectedApproverId != "") {
      if (!isNullOrUndefined(this.filteredSalaryAdvanceEmpList)) {
        for (var i = 0; i < this.filteredSalaryAdvanceEmpList.length; i++) {
          if (
            this.filteredSalaryAdvanceEmpList[i].recDisplayName ==
            selectedApproverId
          ) {
            match = null;
            break;
          } else {
            match = true;
          }
        }
        if (match == true) {
          this.HREmp.employeeSalaryAdvances[index].ApproverInvalid = match;
          return { requireMatchApproverID: match };
        } else {
          this.HREmp.employeeSalaryAdvances[index].ApproverInvalid = false;
        }
      }
    } else {
      this.HREmp.employeeSalaryAdvances[index].ApproverInvalid = false;
      return null;
    }
  }

  addSalaryAdvance() {
    var salaryAdvance = new EmployeeSalaryAdvances();
    salaryAdvance.employeeSalaryAdvanceDetails = [];
    this.HREmp.employeeSalaryAdvances.push(salaryAdvance);
  }

  setMonth(index, start, end) {
    this.Months[index] = [];
    if (start != null && end != null) {
      var startDate = new Date(start);
      var endDate = new Date(end);
      var startMonth = this.monthYearRegex.test(start)
        ? start.format("MMM-YY")
        : new Intl.DateTimeFormat("en-US", { month: "short", year: "2-digit" })
          .format(startDate)
          .split(" ");
      var endMonth = this.monthYearRegex.test(end)
        ? end.format("MMM-YY")
        : new Intl.DateTimeFormat("en-US", { month: "short", year: "2-digit" })
          .format(endDate)
          .split(" ");
      var getCurrentyear = new Date().getFullYear().toString().slice(0, 2);
      this.getMonthsBetween(
        index,
        startMonth[0],
        parseInt(getCurrentyear + startMonth[1].toString()),
        endMonth[0],
        parseInt(getCurrentyear + endMonth[1].toString())
      );
    }
  }

  getMonthsBetween(
    index,
    startMonth: string,
    startYear: number,
    endMonth: string,
    endYear: number
  ) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const startMonthIndex = months.indexOf(startMonth);
    const endMonthIndex = months.indexOf(endMonth);

    const monthsInRange = [];

    let currentMonthIndex = startMonthIndex;
    let currentYear = startYear;

    while (
      currentYear < endYear ||
      (currentYear === endYear && currentMonthIndex <= endMonthIndex)
    ) {
      monthsInRange.push(
        `${months[currentMonthIndex]}-${currentYear.toString().slice(-2)}`
      );

      currentMonthIndex++;

      if (currentMonthIndex > 11) {
        currentMonthIndex = 0;
        currentYear++;
      }
    }

    this.Months[index] = monthsInRange;
    for (var i = 0; i < monthsInRange.length; i++) {
      const month = monthsInRange[i];
      const existingDetailIndex = this.HREmp.employeeSalaryAdvances[
        index
      ].employeeSalaryAdvanceDetails.findIndex(
        (detail) => detail.Month === month
      );
      if (existingDetailIndex !== -1) {
        this.HREmp.employeeSalaryAdvances[index].employeeSalaryAdvanceDetails[
          existingDetailIndex
        ].Month = month;
      } else {
        var salaryAdvances = new EmployeeSalaryAdvanceDetails();
        if (
          this.HREmp.employeeSalaryAdvances[index].employeeSalaryAdvanceDetails[
          i
          ] != null
        ) {
          salaryAdvances =
            this.HREmp.employeeSalaryAdvances[index]
              .employeeSalaryAdvanceDetails[i];
          salaryAdvances.Month = month;
        } else {
          salaryAdvances.Month = month;
          this.HREmp.employeeSalaryAdvances[
            index
          ].employeeSalaryAdvanceDetails.push(salaryAdvances);
        }
      }
    }
    this.HREmp.employeeSalaryAdvances[index].employeeSalaryAdvanceDetails =
      this.HREmp.employeeSalaryAdvances[
        index
      ].employeeSalaryAdvanceDetails.filter((detail) => {
        return monthsInRange.includes(detail.Month);
      });
    if (!this.destroyed) this.cdr.detectChanges();
  }

  addCarLease() {
    var carLease = new EmployeeCarLeases();
    carLease.employeeCarLeaseDetails = [];
    this.HREmp.employeeCarLeases.push(carLease);
  }

  setCarLeaseMonth(index, start, end) {
    this.Months[index] = [];
    if (start != null && end != null) {
      var startDate = new Date(start);
      var endDate = new Date(end);
      var startMonth = this.monthYearRegex.test(start)
        ? start.format("MMM-YY").split("-")
        : new Intl.DateTimeFormat("en-US", { month: "short", year: "2-digit" })
          .format(startDate)
          .split(" ");
      var endMonth = this.monthYearRegex.test(end)
        ? end.format("MMM-YY").split("-")
        : new Intl.DateTimeFormat("en-US", { month: "short", year: "2-digit" })
          .format(endDate)
          .split(" ");
      var getCurrentyear = new Date().getFullYear().toString().slice(0, 2);
      this.getCarLeaseMonthsBetween(
        index,
        startMonth[0],
        parseInt(getCurrentyear + startMonth[1].toString()),
        endMonth[0],
        parseInt(getCurrentyear + endMonth[1].toString())
      );
    }
  }

  getCarLeaseMonthsBetween(
    index,
    startMonth: string,
    startYear: number,
    endMonth: string,
    endYear: number
  ) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const startMonthIndex = months.indexOf(startMonth);
    const endMonthIndex = months.indexOf(endMonth);

    const monthsInRange = [];

    let currentMonthIndex = startMonthIndex;
    let currentYear = startYear;

    while (
      currentYear < endYear ||
      (currentYear === endYear && currentMonthIndex <= endMonthIndex)
    ) {
      monthsInRange.push(
        `${months[currentMonthIndex]}-${currentYear.toString().slice(-2)}`
      );

      currentMonthIndex++;

      if (currentMonthIndex > 11) {
        currentMonthIndex = 0;
        currentYear++;
      }
    }

    this.carLeaseMonths[index] = monthsInRange;
    for (var i = 0; i < monthsInRange.length; i++) {
      const month = monthsInRange[i];
      const existingDetailIndex = this.HREmp.employeeCarLeases[
        index
      ].employeeCarLeaseDetails.findIndex((detail) => detail.Month === month);
      if (existingDetailIndex !== -1) {
        this.HREmp.employeeCarLeases[index].employeeCarLeaseDetails[
          existingDetailIndex
        ].Month = month;
      } else {
        var carLeases = new EmployeeCarLeaseDetails();
        if (
          this.HREmp.employeeCarLeases[index].employeeCarLeaseDetails[i] != null
        ) {
          carLeases =
            this.HREmp.employeeCarLeases[index].employeeCarLeaseDetails[i];
          carLeases.Month = month;
        } else {
          carLeases.Month = month;
          this.HREmp.employeeCarLeases[index].employeeCarLeaseDetails.push(
            carLeases
          );
        }
      }
    }
    this.HREmp.employeeCarLeases[index].employeeCarLeaseDetails =
      this.HREmp.employeeCarLeases[index].employeeCarLeaseDetails.filter(
        (detail) => {
          return monthsInRange.includes(detail.Month);
        }
      );
    if (!this.destroyed) this.cdr.detectChanges();
  }

  getCurrentFinancialYear(): number {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    return year;
  }

  setMinRecoveryDate(recoveryStartMonth) {
    var minRecoveryDate;
    if (recoveryStartMonth != null) {
      var date = new Date(recoveryStartMonth);
      const currentFinancialYear = this.getCurrentFinancialYear();
      const monthYearParts = this.monthYearRegex.test(recoveryStartMonth)
        ? recoveryStartMonth.split("-")
        : new Intl.DateTimeFormat("en-US", { month: "short", year: "2-digit" })
          .format(date)
          .split(" ");
      const monthStr = monthYearParts[0];
      const yearStr = parseInt(
        currentFinancialYear.toString().slice(0, 2) +
        monthYearParts[1].toString()
      );
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const monthIndex = months.indexOf(monthStr);

      minRecoveryDate = new Date(+yearStr, monthIndex, 1);
    }
    return minRecoveryDate;
  }

  fetchURl(url) {
    this.emp_Svc
      .getDownloadURL(url)
      .subscribe((data: any) => {
        window.open(data, '_blank');
      });
  }

  setCurrentDate(recoveryStartMonth) {
    if (recoveryStartMonth != null) {
      var date = new Date(recoveryStartMonth);
      var currentDate = new Date();
      const currentFinancialYear = this.getCurrentFinancialYear();
      const monthYearParts = this.monthYearRegex.test(recoveryStartMonth)
        ? recoveryStartMonth.split("-")
        : new Intl.DateTimeFormat("en-US", { month: "short", year: "2-digit" })
          .format(date)
          .split(" ");
      const monthStr = monthYearParts[0];
      const yearStr = parseInt(
        currentFinancialYear.toString().slice(0, 2) +
        monthYearParts[1].toString()
      );
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const monthIndex = months.indexOf(monthStr);
      var firstDayOfMonth = new Date(+yearStr, monthIndex, 1);
      return firstDayOfMonth > new Date()
        ? new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)
        : firstDayOfMonth;
    } else {
      var date = new Date();
      return new Date(date.getFullYear(), date.getMonth(), 1);
    }
  }

  isDisabled(recoveryStartMonth) {
    var firstDayOfNextMonth;
    if (recoveryStartMonth != null) {
      var date = new Date(recoveryStartMonth);
      const currentFinancialYear = this.getCurrentFinancialYear();
      const monthYearParts = this.monthYearRegex.test(recoveryStartMonth)
        ? moment(recoveryStartMonth, "MMM-YY").format("MMM-YY").split("-")
        : new Intl.DateTimeFormat("en-US", { month: "short", year: "2-digit" })
          .format(date)
          .split(" ");
      const monthStr = monthYearParts[0];
      const yearStr = parseInt(
        currentFinancialYear.toString().slice(0, 2) +
        monthYearParts[1].toString()
      );
      const months = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ];
      const monthIndex = months.indexOf(monthStr);
      firstDayOfNextMonth = new Date(+yearStr, monthIndex + 1, 1);
      const lastDayOfMonth = new Date(
        firstDayOfNextMonth.setDate(firstDayOfNextMonth.getDate() - 1)
      );
      if (new Date() > lastDayOfMonth) {
        return true;
      } else {
        return false;
      }
    }
  }
}
